export default __webpack_public_path__ + "static/fraol-4fcb4d8d67446e02183e01e13e8ce171.webp";